module.exports = __webpack_public_path__ + "static/media/avatar-2.02aea0c2.jpg";